import {inject} from '@angular/core';
import {TranslateService as RuntimeTranslateService} from '@ngx-translate/core';
import { Component, OnInit } from '@angular/core';
import { SiteService } from 'src/app/services/site.service';
import { UserService } from 'src/app/services/user.service';
import Swal from 'sweetalert2';
import {CertificationService} from '../../../../services/certification.service';
import {NgxSpinnerService} from 'ngx-spinner';
import {ConfigService} from "../../../../services/config.service";

@Component({
    selector: 'app-add-certification',
    templateUrl: './add-certification.component.html',
    styleUrls: ['./add-certification.component.css'],
    standalone: false
})
export class AddCertificationComponent implements OnInit {
  private readonly runtimeTranslate = inject(RuntimeTranslateService);

  public certification = {
    name: null,
    type_validite: null,
    description: null,
    date: null,
    type: null,
    delay: null,
    id: null,
    code_article: null,
    code_client: null,
    theme: null
  };
  public themes = [
    'Risques généraux',
    'Risques biologiques',
    'Risques chimiques',
    'Risques informatiques',
    'Radioprotection',
    'Accueil sécurité',
    'Autres thèmes (éthique, anticorruption…)'
  ];
  public sites: any[] = [];
  public selectedSiteIds: number[] = [];
  public profile_id = parseInt(localStorage.getItem('profile_id'));
  public addingSuccess: boolean;
  public certificats: any;
  public messageText;
  choice: number;
  readioSelected: number;
  public entityType = this.configService.entityType;

  constructor(private configService: ConfigService, private spinner: NgxSpinnerService, private siteService: SiteService, private userService: UserService, private certificationService: CertificationService) { }

  ngOnInit() {
    this.configService.checkUSerAccessByProfile(this.profile_id);
    this.get_list_certifications();
    this.get_list_sites();
  }
  get_list_certifications() {
    this.spinner.show();
    this.certificationService.getCertificat()
      .subscribe(res => {
        this.certificats = res.data.certificat;
        this.spinner.hide();
      }, (err) => {
        console.log(err);
      });
  }


  add_certificat() {
    if (this.certification.name === null) {
      Swal.fire({
        icon: 'error',
        title: this.runtimeTranslate.instant('alerts.oops'),
        text: this.runtimeTranslate.instant('alerts.checkInputs')
      });
      return false;
    }
    if (this.certification.type === '0' && this.certification.id === null ) {
      Swal.fire({
        icon: 'error',
        title: this.runtimeTranslate.instant('alerts.oops'),
        text: this.runtimeTranslate.instant('alerts.selectCertificate')
      });
      return false;
    }
    const body = {
      name: this.certification.name,
      description: this.certification.description ? this.certification.description : this.certification.name,
      type_validite: this.readioSelected,
      date: this.certification.date,
      certificat_id: this.certification.id,
      type: this.certification.type,
      delay: this.certification.delay,
      code_article: this.certification.code_article,
      code_client: this.certification.code_client,
      theme: this.certification.theme,
      array_site_id : this.selectedSiteIds,
    };
    this.certificationService.addCertificats(body)
      .subscribe(res => {
        this.addingSuccess = true;
        // @ts-ignore: Unreachable code error
        this.messageText = res.message;
        this.certification.name = '';
        this.certification.description = '';
        this.certification.type_validite = '';
        this.certification.date = '';
        this.certification.type = '';
        this.certification.code_article = '';
        this.certification.code_client = '';
        this.certification.theme = '';
        this.get_list_certifications();
        setTimeout (() => {
          this.addingSuccess = false;
        }, 5000);
      }, (err) => {
        this.spinner.hide();
      });
  }

  changeValidite(e) {
    this.readioSelected = e.target.value;
    this.certification.type_validite =  this.readioSelected;
  }

  get_list_sites(): void {
    this.siteService.getSite()
      .subscribe(res => {
        const sites = res.data || [];
        this.sites = sites
          .filter(site => this.entityType !== 'EKAMPUS' || !this.isHiddenEkampusSite(site))
          .sort((a, b) => (a.name || '').localeCompare(b.name || '', 'fr', {sensitivity: 'base'}));
        }, (err) => {
        console.log(err)
      });
  }

  selectAllSites(selectAll: boolean): void {
    this.selectedSiteIds = selectAll ? this.sites.map(site => site.id) : [];
  }

  private isHiddenEkampusSite(site: any): boolean {
    return ((site && site.name) || '').trim().toUpperCase().startsWith('X-');
  }
}
